import React from "react";
import { Badge } from "../GraderUI";

export function ProviderStatusBadges({ result }) {
	if (!result) {
		return <span className="confidence--none">—</span>;
	}

	return (
		<div className="citation-data-grid__status-stack">
			{result.cited ? <Badge variant="success">Cited</Badge> : null}
			{result.mentioned ? <Badge variant="info">Mentioned</Badge> : null}
			{!result.cited && !result.mentioned ? (
				<Badge variant="secondary">Not cited</Badge>
			) : null}
		</div>
	);
}

export default ProviderStatusBadges;
